import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { painPoints } from '../data/landing';
export function PainPointsSection() {
  return <section aria-labelledby="reconoces" className="bg-stone-50" data-id="element-148" data-mp="2worl3y57a7g0">
      
    </section>;
}